import React from 'react';
import { Plus, Trash2, MessageCircle, Archive } from 'lucide-react';
import { whatsappTemplates, openWhatsApp } from './adminUtils';

const MatchesTab = ({ ctx }) => {
  const {
    players, matches,
    newMatch, setNewMatch,
    editingMatch, setEditingMatch,
    handleCreateMatch, handleUpdateMatch, handleToggleMatchOpen,
    handleTogglePlayerConfirmation, handleDeleteMatch, handleArchiveMatch,
    handleOpenSessionAwards, handleCloseSessionAwards,
  } = ctx;

  return (
    <div className="card">
      <h2 className="text-3xl font-bold mb-6">GERENCIAR PARTIDAS</h2>

      {/* Create Match Form */}
      <form onSubmit={handleCreateMatch} className="mb-8 border-2 border-black p-6">
        <h3 className="text-2xl font-bold mb-4">Nova Partida</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          <div>
            <label className="block text-lg font-bold mb-2">Data</label>
            <input
              type="date"
              value={newMatch.date}
              onChange={(e) => setNewMatch({ ...newMatch, date: e.target.value })}
              className="input-field"
              data-testid="match-date-input"
            />
          </div>
          <div>
            <label className="block text-lg font-bold mb-2">Horário</label>
            <input
              type="time"
              value={newMatch.time}
              onChange={(e) => setNewMatch({ ...newMatch, time: e.target.value })}
              className="input-field"
              data-testid="match-time-input"
            />
          </div>
          <div>
            <label className="block text-lg font-bold mb-2">Local</label>
            <input
              type="text"
              value={newMatch.location}
              onChange={(e) => setNewMatch({ ...newMatch, location: e.target.value })}
              className="input-field"
              placeholder="Ex: Campo do Bairro"
              data-testid="match-location-input"
            />
          </div>
          <div>
            <label className="block text-lg font-bold mb-2">Link do Local <span className="text-xs font-normal text-zinc-400">(opcional)</span></label>
            <input
              type="url"
              value={newMatch.location_url || ''}
              onChange={(e) => setNewMatch({ ...newMatch, location_url: e.target.value })}
              className="input-field"
              placeholder="https://maps.google.com/..."
              data-testid="match-location-url-input"
            />
          </div>
          <div>
            <label className="block text-lg font-bold mb-2">Vagas Totais</label>
            <input
              type="number"
              min="1"
              value={newMatch.total_spots}
              onChange={(e) => setNewMatch({ ...newMatch, total_spots: parseInt(e.target.value) || 14 })}
              className="input-field"
              data-testid="match-spots-input"
            />
          </div>
          <div>
            <label className="block text-lg font-bold mb-2">Custo Campo (€)</label>
            <input
              type="number"
              min="0"
              step="0.5"
              value={newMatch.field_cost}
              onChange={(e) => setNewMatch({ ...newMatch, field_cost: parseFloat(e.target.value) || 50 })}
              className="input-field"
              data-testid="match-field-cost-input"
            />
          </div>
          <div>
            <label className="block text-lg font-bold mb-2">Valor/Jogador (€)</label>
            <input
              type="number"
              min="0"
              step="0.10"
              value={newMatch.player_price}
              onChange={(e) => setNewMatch({ ...newMatch, player_price: parseFloat(e.target.value) || 2.50 })}
              className="input-field"
              data-testid="match-player-price-input"
            />
          </div>
        </div>
        <button type="submit" className="btn-primary w-full" data-testid="create-match-btn">
          <Plus className="inline mr-2" size={24} strokeWidth={3} />
          CRIAR PARTIDA
        </button>
      </form>

      {/* Matches List */}
      <div className="space-y-6">
        {matches.length === 0 ? (
          <p className="text-center text-xl text-gray-400">Nenhuma partida criada</p>
        ) : (
          matches.map((match) => (
            <div key={match.id} className="border-2 border-black p-6">
              {editingMatch && editingMatch.id === match.id ? (
                <div className="space-y-4">
                  <h3 className="text-xl font-bold mb-4">✏️ Editar Partida</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-bold mb-1">Data</label>
                      <input type="date" value={editingMatch.date} onChange={(e) => setEditingMatch({ ...editingMatch, date: e.target.value })} className="input-field" />
                    </div>
                    <div>
                      <label className="block text-sm font-bold mb-1">Horário</label>
                      <input type="time" value={editingMatch.time} onChange={(e) => setEditingMatch({ ...editingMatch, time: e.target.value })} className="input-field" />
                    </div>
                    <div>
                      <label className="block text-sm font-bold mb-1">Local</label>
                      <input type="text" value={editingMatch.location} onChange={(e) => setEditingMatch({ ...editingMatch, location: e.target.value })} className="input-field" />
                    </div>
                    <div>
                      <label className="block text-sm font-bold mb-1">Vagas</label>
                      <input type="number" min="1" value={editingMatch.total_spots} onChange={(e) => setEditingMatch({ ...editingMatch, total_spots: parseInt(e.target.value) || 14 })} className="input-field" />
                    </div>
                    <div>
                      <label className="block text-sm font-bold mb-1">Custo Campo (€)</label>
                      <input type="number" min="0" step="0.5" value={editingMatch.field_cost || 50} onChange={(e) => setEditingMatch({ ...editingMatch, field_cost: parseFloat(e.target.value) || 50 })} className="input-field" />
                    </div>
                    <div>
                      <label className="block text-sm font-bold mb-1">Valor/Jogador (€)</label>
                      <input type="number" min="0" step="0.10" value={editingMatch.player_price || 2.50} onChange={(e) => setEditingMatch({ ...editingMatch, player_price: parseFloat(e.target.value) || 2.50 })} className="input-field" />
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <button type="button" onClick={() => handleUpdateMatch(match.id)} className="btn-primary flex-1">✅ SALVAR</button>
                    <button type="button" onClick={() => setEditingMatch(null)} className="btn-secondary flex-1">❌ CANCELAR</button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <h3 className="text-2xl font-bold">
                        {match.is_open ? '🟢' : '🔴'} {match.date} - {match.time}
                      </h3>
                      <p className="text-lg">📍 {match.location_url ? (
                        <a href={match.location_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" onClick={(e) => e.stopPropagation()} data-testid={`admin-match-loc-link-${match.id}`}>{match.location}</a>
                      ) : match.location}</p>
                      <p className="text-base text-gray-600">
                        {match.confirmed_players.length}/{match.total_spots} confirmados
                      </p>
                      <p className="text-sm text-gray-500 mt-1">
                        💰 Campo: {match.field_cost || 50}€ | Por jogador: {match.player_price || 2.75}€
                      </p>

                      <button
                        onClick={() => handleToggleMatchOpen(match.id, !match.is_open)}
                        className={`mt-3 px-4 py-2 font-bold border-2 ${
                          match.is_open
                            ? 'bg-red-100 border-red-500 text-red-700 hover:bg-red-200'
                            : 'bg-green-100 border-green-500 text-green-700 hover:bg-green-200'
                        }`}
                        data-testid={`toggle-open-${match.id}`}
                      >
                        {match.is_open ? '🔒 FECHAR VAGAS' : '🔓 LIBERAR VAGAS'}
                      </button>
                      {!match.is_open && (
                        <p className="text-xs text-red-600 mt-1">⚠️ Partida não visível na página pública</p>
                      )}

                      {/* Awards Voting Controls */}
                      {match.confirmed_players?.length > 0 && (
                        <div className="mt-3 p-3 bg-yellow-50 border-2 border-yellow-400 rounded">
                          <p className="text-sm font-bold text-yellow-800 mb-2">🏆 Prémios da Rodada</p>
                          {match.awards_closed ? (
                            <div className="text-sm">
                              <span className="inline-block px-2 py-1 bg-green-200 text-green-800 font-bold rounded mb-1">✅ Encerrada</span>
                              {match.awards_winners && Object.keys(match.awards_winners).length > 0 && (
                                <ul className="list-disc list-inside mt-2">
                                  {match.awards_winners.puskas && <li>🥇 Puskás: <strong>{match.awards_winners.puskas.name}</strong></li>}
                                  {match.awards_winners.pintura && <li>🎨 Pintura: <strong>{match.awards_winners.pintura.name}</strong></li>}
                                  {match.awards_winners.melhor_defesa && <li>🧤 Melhor Defesa: <strong>{match.awards_winners.melhor_defesa.name}</strong></li>}
                                </ul>
                              )}
                            </div>
                          ) : match.awards_voting_open ? (
                            <button
                              onClick={() => handleCloseSessionAwards(match.id)}
                              className="px-3 py-2 bg-yellow-600 hover:bg-yellow-700 text-white font-bold text-sm rounded"
                              data-testid={`close-awards-${match.id}`}
                            >
                              🛑 Encerrar Votação dos Prémios
                            </button>
                          ) : (
                            <button
                              onClick={() => handleOpenSessionAwards(match.id)}
                              className="px-3 py-2 bg-yellow-500 hover:bg-yellow-600 text-white font-bold text-sm rounded"
                              data-testid={`open-awards-${match.id}`}
                            >
                              🏆 Abrir Votação dos Prémios
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="flex gap-2">
                      <button onClick={() => setEditingMatch({ ...match })} className="text-blue-600 hover:text-blue-800" data-testid={`edit-match-${match.id}`}>✏️</button>
                      <button
                        onClick={() => handleArchiveMatch(match.id)}
                        className="text-purple-600 hover:text-purple-800"
                        title="Arquivar partida (move para o caixa)"
                        data-testid={`archive-match-${match.id}`}
                      >
                        <Archive size={22} strokeWidth={2.5} />
                      </button>
                      <button onClick={() => handleDeleteMatch(match.id)} className="text-red-600 hover:text-red-800" data-testid={`delete-match-${match.id}`}>
                        <Trash2 size={24} strokeWidth={2.5} />
                      </button>
                    </div>
                  </div>

                  <div>
                    <p className="text-lg font-bold mb-3">Marcar jogadores confirmados:</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                      {players.map((player) => {
                        const isConfirmed = match.confirmed_players.includes(player.name);
                        return (
                          <div
                            key={player.name}
                            className="flex items-center justify-between gap-2 border-2 border-black p-3"
                            style={{ backgroundColor: isConfirmed ? '#FFF7ED' : 'white' }}
                          >
                            <label className="flex items-center gap-3 cursor-pointer flex-1">
                              <input
                                type="checkbox"
                                checked={isConfirmed}
                                onChange={(e) => handleTogglePlayerConfirmation(match.id, player.name, e.target.checked)}
                                className="w-6 h-6 border-2 border-black cursor-pointer"
                                style={{ accentColor: '#FF4500' }}
                                data-testid={`confirm-${match.id}-${player.name}`}
                              />
                              <span className="font-bold">{player.name}</span>
                            </label>
                            {player.phone && (
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  openWhatsApp(
                                    player.phone,
                                    isConfirmed
                                      ? whatsappTemplates.escalado(player.name, match.date, match.time)
                                      : whatsappTemplates.convite(player.name, match.date, match.time, match.location)
                                  );
                                }}
                                className="bg-green-500 hover:bg-green-600 text-white text-xs px-2 py-1 rounded flex-shrink-0"
                                title={isConfirmed ? "Avisar escalação" : "Convidar para partida"}
                                data-testid={`whatsapp-match-${match.id}-${player.name}`}
                              >
                                <MessageCircle size={14} />
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>

                    {match.confirmed_players.length > 0 && (
                      <div className="mt-4 p-4 bg-green-50 border-2 border-green-500">
                        <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                          <p className="font-bold text-green-700">📱 Avisar confirmados via WhatsApp:</p>
                          {(() => {
                            const playersWithPhone = match.confirmed_players
                              .map(name => players.find(p => p.name === name))
                              .filter(p => p?.phone);

                            if (playersWithPhone.length > 1) {
                              return (
                                <button
                                  onClick={() => {
                                    if (window.confirm(`Isto vai abrir ${playersWithPhone.length} janelas do WhatsApp. Continuar?`)) {
                                      playersWithPhone.forEach((player, index) => {
                                        setTimeout(() => {
                                          openWhatsApp(
                                            player.phone,
                                            whatsappTemplates.escalado(player.name, match.date, match.time)
                                          );
                                        }, index * 800);
                                      });
                                    }
                                  }}
                                  className="bg-green-700 hover:bg-green-800 text-white font-bold px-4 py-2 rounded flex items-center gap-2"
                                  data-testid={`whatsapp-all-${match.id}`}
                                >
                                  <MessageCircle size={18} /> AVISAR TODOS ({playersWithPhone.length})
                                </button>
                              );
                            }
                            return null;
                          })()}
                        </div>

                        <div className="flex flex-wrap gap-2">
                          {match.confirmed_players.map(playerName => {
                            const player = players.find(p => p.name === playerName);
                            if (!player?.phone) return null;
                            return (
                              <button
                                key={playerName}
                                onClick={() => openWhatsApp(
                                  player.phone,
                                  whatsappTemplates.escalado(playerName, match.date, match.time)
                                )}
                                className="bg-green-600 hover:bg-green-700 text-white text-sm px-3 py-1 rounded flex items-center gap-1"
                                data-testid={`whatsapp-confirmed-${match.id}-${playerName}`}
                              >
                                <MessageCircle size={12} /> {playerName}
                              </button>
                            );
                          })}
                        </div>

                        {(() => {
                          const withPhone = match.confirmed_players.filter(name =>
                            players.find(p => p.name === name)?.phone
                          ).length;
                          const withoutPhone = match.confirmed_players.length - withPhone;

                          return (
                            <p className="text-xs text-gray-500 mt-2">
                              ✅ {withPhone} com telefone
                              {withoutPhone > 0 && (
                                <span className="text-orange-600 ml-2">
                                  ⚠️ {withoutPhone} sem telefone cadastrado
                                </span>
                              )}
                            </p>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MatchesTab;
